import { render } from "./MTabs.vue?vue&type=template&id=594a4aea&scoped=true"
import script from "./MTabs.vue?vue&type=script&lang=js"
export * from "./MTabs.vue?vue&type=script&lang=js"

import "./MTabs.vue?vue&type=style&index=0&id=594a4aea&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594a4aea"]])

export default __exports__